import { QR_CODE_GRADIENT_TYPES, QRCODE_DYNAMIC_MICROSITE_TYPE } from '~/constants/qr-code';

import { PATH } from './route-path';

export const BASE_API_URL = process.env.BASE_API_URL;
export const GOOGLE_MAP_KEY = process.env.GOOGLE_MAP_KEY;
export const REDIRECT_QR_URI = process.env.REDIRECT_QR_URI;
export const CLOUDFLARE_KEY = process.env.CLOUDFLARE_KEY;
export const MAX_ROTATE_VALUE = 180;
export const SHOW_LOL_COVER_UPLOAD_BUTTON = [0, 7, 8];
export const TABLET_MIN_WIDTH = 768;
export const DESKTOP_MIN_WIDTH = 1025;
export const MAX_CONTENT_WIDTH = 1366;

export const IS_PRODUCTION = process.env.ENV === 'FE_PROD';

export const APP_SCREEN_NAMES = {
  WEBSITE: '0',
  PDF: '1',
  LIST_OF_LINKS: '2',
  APPS: '3',
  IMAGES: '4',
  VCARD_PLUS: '5',
  SOCIAL_MEDIA: '6',
  COUPON: '7',
};

export const FONTS = [
  {
    value: 'Courier New, monospace',
    label: 'Courier New',
  },
  {
    value: 'Garamond, serif',
    label: 'Garamond',
  },
  {
    value: 'Georgia, serif',
    label: 'Georgia',
  },
  {
    value: 'Times New Roman, serif',
    label: 'New Roman',
  },
  {
    value: 'Roboto, sans-serif',
    label: 'Roboto',
  },
];

export const MICROSITE_TYPES = [
  QRCODE_DYNAMIC_MICROSITE_TYPE.WEBSITE,
  QRCODE_DYNAMIC_MICROSITE_TYPE.PDF,
  QRCODE_DYNAMIC_MICROSITE_TYPE.LINKS,
  QRCODE_DYNAMIC_MICROSITE_TYPE.APP,
  QRCODE_DYNAMIC_MICROSITE_TYPE.IMAGES,
  QRCODE_DYNAMIC_MICROSITE_TYPE.VCARD_PLUS,
  QRCODE_DYNAMIC_MICROSITE_TYPE.SOCIAL_MEDIA,
  QRCODE_DYNAMIC_MICROSITE_TYPE.COUPON,
  QRCODE_DYNAMIC_MICROSITE_TYPE.VIDEO,
];

export const REDIRECT_URI = `${window.location.origin}${PATH.LOGIN}`;

export const IS_ACTIVE_SUBSCRIPTION_STATUS = 'active';
export const IS_TRIAL_SUBSCRIPTION_STATUS = 'trial';

export const GRADIENT_TYPES = [
  { value: QR_CODE_GRADIENT_TYPES.vertical, label: 'Vertical Gradiant' },
  { value: QR_CODE_GRADIENT_TYPES.radial, label: 'Radial Gradiant' },
  { value: QR_CODE_GRADIENT_TYPES.square, label: 'Square Gradiant' },
  { value: QR_CODE_GRADIENT_TYPES.horizontal, label: 'Horizontal Gradiant' },
];
export const separators = [
  { value: '.', label: '.' },
  { value: ',', label: ',' },
];

export const DEFAULT_QR_CODE_STYLES = {
  errorCorrectionLevel: 'Q',
  shape: {
    transparent_bg: false,
    backgroundColor: '#ffffff',
    color: '#000000',
    style: 'square',
  },
  corner_border: {
    style: 1,
    color: '#000000',
  },
  corner_center: {
    style: IS_PRODUCTION ? 2 : 16,
    color: '#000000',
  },
  frame: {
    style: 34,
    color: '#000000',
    phrase: 'Scan me!',
    phrase_color: '#ffffff',
  },
};

export const BASIC_GRADIENT_STYLES = {
  type: GRADIENT_TYPES[0]?.value,
  startColor: '#000000',
  endColor: '#ffffff',
};

export const NEW_QR_CODES_INDEXES = [7, 8]; // for new forms flow in builder
export const NEW_QR_CODES_TEMPLATE_IDS = [QRCODE_DYNAMIC_MICROSITE_TYPE.COUPON, QRCODE_DYNAMIC_MICROSITE_TYPE.VIDEO]; // for new forms flow in builder
export const BUILDER_BOTTOM_NAVIGATION_ID = 'builder_bottom_navigation';

export const PREVIEW_BAR_VIEW_TYPE = {
  PHONE: 'PHONE',
  QRCODE: 'QRCODE',
} as const;

export const YouTubeURLRegexp = /^(?:https?:\/\/)?(?:www\.)?youtube\.com\/(?:watch\?(?:.*&)?v=|v\/)([a-zA-Z0-9_-]{11})/;
